<template>
    <div class="facilities">
        <div class="title">
            {{ $t("Facilities") }}
        </div>
        <div class="description">
            {{ $t("*The booking guest is to register at the reception in Fairy Park Heritage City. The booking time slot will only be held for an hour, it will automatically be cancelled in case of a no-show. For any enquiries, kindly contact +6016 - 330 6138.") }}
        </div>
        <div v-if="isFacilityLoading" v-loading="loading" class="text-center">
            <div class="spinner-border text-primary" role="status"></div>
        </div>
        <div v-else>
            <div v-if="length > 0" class="facility-list">
                <div class="facility-item" v-for="item in facilityList" :key="item.id">
                    <img :src="getAssetPath(item.banner)">
                    <div class="facility-text">
                        <div class="facility-title">
                            {{ item.name }}
                        </div>
                        <div class="facility-book" @click="goToBooking(item.id)">
                            {{ $t("Book") }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="pt-4 text-center">
                {{ $t("No data found") }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Facilities',
        data() {
            return {
                isFacilityLoading: true,
                slugList: ['ktv', 'gym', 'kids-pool', 'swimming-pool', 'ping-pong', 'badminton', 'basketball', 'stone-art', 'water-park'],
                facilityList: [],
                length: 0,
            }
        },
        mounted () {
            this.getFacility();
        },
        methods: {
            getFacility() {
                this.$api.requestByGet('facilities').then((result) => {
                    this.isFacilityLoading = false;
                    if (result.success) {
                        for (var i = 0; i < result.data.length; i++) {
                            if (this.slugList.includes(result.data[i]['facility_type']['slug'])) {
                                let facility = result.data[i]['facility_type'];
                                facility.banner = result.data[i]['banner'];
                                this.facilityList.push(facility);
                                var index = this.slugList.indexOf(result.data[i]['facility_type']['slug']);
                                if (index >= 0) {
                                    this.slugList.splice(index, 1);
                                }
                            }
                        }
                        this.length = this.facilityList.length;
                    } else {
                        this.$message.error(this.$t("Failed, please try again!"));
                    }
                }).catch(error => {
                    this.isFacilityLoading = false;
                    this.$message.error(error.message);
                });
            },
            getAssetPath(banner) {
                if (!banner) {
                    return '';
                }
                var url = 'https://crm.fairypark.asia';
                var assetPath = url + banner;
                return assetPath;
            },
            goToBooking(id) {
                this.$router.push({path: '/booking',  query: {'id': id}});
            }
        },
    }
</script>

<style lang="scss">
    @import '../styles/facilities.scss';
</style>